import React from 'react'
import axios from 'axios';
import { useState, useEffect } from 'react';

function HouseRaceTile({ state, district, year }) {


    const [housecandidates, setHouseCandidates] = useState([]);
    const getHouseCandidates = async () => {
        axios.get("/api/v1/congress/houseRace/" + state + "/" + district + "/" + year)
            .then((result) => {
                setHouseCandidates(result.data);
            })
            .catch((err) => console.log(err));

    };

    useEffect(() => {
        getHouseCandidates();
    });
    return (
        <div>
            <div className="content-card links">
                <a href={"/House/" + year + "/" + state + "/" + district}>
                    <div className="content-image">
                        <div>
                            {district > 0 ?
                                <center>District {district}</center>
                                :
                                <center>at-large</center>
                            }
                        </div>
                    </div>
                </a>
                <div className="content-details">
                    {housecandidates.map((candidate, index) => (
                        <a href={"/House/" + year + "/" + state + "/" + district}>

                            <div className="content-text">{candidate.name} ({candidate.party})</div>
                        </a>
                    ))}

                </div>
            </div>
        </div >
    )
}



export default HouseRaceTile
